import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllParallelJob = (page, currentRowsPerPage) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.getAllParallelJob(page, currentRowsPerPage).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETPARALLELJOBSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETPARALLELJOBFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETPARALLELJOBFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getParallelJobById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getParallelJobById(id).then(res => {
        // // 
        if (JSON.parse(res).status == 200) {
            
            dispatch({
                type: ActionTypes.GETPARALLELJOBBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETPARALLELJOBBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETPARALLELJOBBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveParallelJob = (data, navigate) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.saveParallelJob(data).then(res => {
        // // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEPARALLELJOBSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
            navigate('/batch')
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEPARALLELJOBFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.SAVEPARALLELJOBFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateParallelJob = (data, id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateParallelJob(data, id).then(res => {
        // // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATEPARALLELJOBSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATEPARALLELJOBFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.UPDATEPARALLELJOBFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleParallelJob = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleParallelJob(id).then(res => {
        // // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLEPARALLELJOBSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLEPARALLELJOBFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLEPARALLELJOBFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}